// extracted by mini-css-extract-plugin
export var skinContained = "schema-grid-module--skinContained--2809a";